import { api } from "@/lib/api";
import type { ListingMapPoint } from "@/components/ListingsMap";

// Map pins survive route changes here (module scope) so returning to a page
// with a map paints it instantly from the last fetch while a background
// refetch keeps it current — the startup effects re-run on every navigation,
// and without this the map sits empty until the network answers.
const mapPointsCache = new Map<string, ListingMapPoint[]>();

/** Fetch a pin set (active listings or coming-soon deals) through the shared
    cache. Used by the buyer marketplace (Home) and the admin All Listings page,
    which render the same <MarketExplorer />. */
export function loadMapPoints(
  url: string,
  userId: string,
  apply: (pts: ListingMapPoint[]) => void,
  setLoading?: (loading: boolean) => void,
) {
  // Keyed by user so a different sign-in never briefly sees the previous
  // viewer's pin set (advance-access windows differ per tier).
  const key = `${userId}:${url}`;
  const cached = mapPointsCache.get(key);
  if (cached) apply(cached);
  // Only show the loader on a cold fetch — cached pins paint immediately and
  // the background revalidation shouldn't flash a spinner over them.
  setLoading?.(!cached);
  api.get<ListingMapPoint[]>(url)
    .then((data) => {
      mapPointsCache.set(key, data);
      apply(data);
    })
    .catch(() => {})
    .finally(() => setLoading?.(false));
}
